import React, { useEffect, useState } from 'react';

const ProgressBarStatus = ({ statusDescription }) => {
  const [steps, setSteps] = useState([]);

  useEffect(() => {
    if (statusDescription) {
      try {
        const parsedSteps = typeof statusDescription === 'string' ? JSON.parse(statusDescription) : statusDescription;
        setSteps(parsedSteps);
      } catch (error) {
        console.error("Error parsing status description:", error);
      }
    }
  }, [statusDescription]);

  const formatTime = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div className="progressbarstatus">
      {steps.map((step, index) => (
        <div key={index} className={`steps ${step.IsActive ? 'active' : ''}`}>
          <div className={`steps-number ${step.IsActive ? 'active' : ''}`}>✔</div>
          <div className={`steps-description ${step.IsActive ? 'active' : ''}`}>
            <div>{step.Step}</div>
            {step.Description && <div className="step-time">{formatTime(step.Description)}</div>}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProgressBarStatus;
